import { Component, Input, OnInit, OnChanges, SimpleChanges  } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { Globals } from 'src/app/shared/globals';


@Component({
  selector: 'programme-unit',
  templateUrl: './programme-unit.component.html',
  styleUrls: ['../programme.component.css']
})
export class ProgrammeUnitComponent {


  @Input('unit') units: any;
  @Input('selection') selection: any;
  @Input('year') selectedSchoolYear: any;
  @Input('learning-path') learningPath : any;
  @Input('period') period: any;
  @Input('period-count') periodCount: any;
  @Input('start-semester') startSemester: any;
  @Input('duration') duration: any;

  private scrollPositions = new Map<string, number>();

  constructor(
    public globals: Globals,
    private router: Router
  ) {
    //console.log('periodi on: ' + this.period)
    //console.log(this.periodCount);

  }

  filterAccomplishmentPlanSemesterList(accomplishmentPlanSemesterList: any) {
    return accomplishmentPlanSemesterList.slice(this.selectedSchoolYear, accomplishmentPlanSemesterList.length);
  }

  //Tätä ei ole muutettu pääkomponentin mukaiseksi. Pitäisikö olla?
  filterAccomplishmentPlanList(accomplishmentPlanList: any) {
    return accomplishmentPlanList.slice(this.selectedSchoolYear, accomplishmentPlanList.length);
  }


  /*filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any) {
    return accomplishmentPlanPeriodList.slice(this.sum(this.periodCount.slice(0, this.selectedSchoolYear)), this.sum(this.periodCount.slice(0, this.selectedSchoolYear+1)));
    
  }*/
  /*filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any, accomplishmentPlanYearList: any) {
    let periodCount = Math.ceil(accomplishmentPlanPeriodList.length / accomplishmentPlanYearList.length);
    //console.log(periodCount);
    return accomplishmentPlanPeriodList.slice((this.selectedSchoolYear * periodCount - periodCount), this.selectedSchoolYear * periodCount);
  }*/

filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any, accomplishmentPlanYearList: any) {
    const totalPeriods = accomplishmentPlanPeriodList.length;
    const periodsPerYear = Math.round(totalPeriods / this.duration);
    const offset = this.startSemester * Math.floor(periodsPerYear / 2);
    const firstYearPeriods = periodsPerYear - offset;

    let start: number;
    let end: number;

    if (this.selectedSchoolYear === 1) {
        start = 0;
        end = firstYearPeriods;
    } else {
        start = firstYearPeriods + (this.selectedSchoolYear - 2) * periodsPerYear;
        end = start + periodsPerYear;
    }

    return accomplishmentPlanPeriodList.slice(start, end);
}

  sum(list: any): any {
    const sum = list.reduce((partialSum: any, a: any) => partialSum + a, 0);
    //console.log("summa: " +  sum);
    return sum;
  }

  includesLearningPath(unit: any) {
    // palautetaan true, jos ei opintopolkuja valu
    return this.learningPath ? unit.learningPathIds.includes(this.learningPath) : true;
  }

  /*rememberScroll(event: MouseEvent) {
  // Optionally: Extract the current route here if you care about "where you're leaving from"
  const key = this.router.url;
  const container = document.querySelector('.mat-sidenav-content'); // Substitute your real class/id
  const scrollY = container ? container.scrollTop : 0;
  //const scrollY = window.scrollY; // or from container if needed
  this.scrollPositions.set(key, scrollY);
  // For debug
  console.log(`Saved scrollY: ${scrollY} for ${key}`);
}

getScrollY(): number {
  const container = document.querySelector('mat-sidenav-content');
  return container ? container.scrollTop : 0;
}

setScrollY(y: number) {
  const container = document.querySelector('mat-sidenav-content');
  if (container) container.scrollTop = y;
}*/

}



